<template>
  <section className="account-activation-success-design-form">

    <h5 className="mt-4">Image Settings</h5>
    <hr>

    <!--  Image Tint Strength -->
    <b-form-group
      id="input-group-2"
      label="Image tint strength"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-input
        v-model="form.imageTintStrength"
        type="range"
        min="1"
        max="100"
        step="1"
      />
      {{ form.imageTintStrength }}%
    </b-form-group>
    <!--  / Image Tint Strength -->

    <!--  Image tint style -->
    <b-form-group
      id="input-group-2"
      label="Image tint style"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.imageTintStyle"
        :options="imageTintStyleOptions"
      />
    </b-form-group>
    <!--  / Image tint style -->

    <!--  Modal Content Direction -->
    <b-form-group
      id="input-group-2"
      label="Content Display Layout"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.modalContentDirection"
        :options="modalContentDirectionOptions"
      />
    </b-form-group>
    <!-- / Modal Content Direction -->

    <h5 className="mt-4">Buttons Settings</h5>
    <hr>

    <!-- Primary Link Button Type -->
    <b-form-group
      v-if="contentSettings.primaryButtonActive"
      id="input-group-2"
      label="Primary Button Style"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.primaryLinkButtonType"
        :options="buttonTypeOptions"
      />
    </b-form-group>
    <!-- / Primary Link Button Type -->

    <!-- Primary Link Button Icon -->
    <b-form-group
      v-if="contentSettings.primaryButtonActive"
      id="input-group-2"
      label="Primary Button Icon"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.primaryLinkButtonIcon"
        :options="buttonIconOptions"
      />
    </b-form-group>
    <!-- / Primary Link Button Icon -->

    <!-- Secondary Link Button Type -->
    <b-form-group
      v-if="contentSettings.secondaryButtonActive"
      id="input-group-2"
      label="Secondary Button Type"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.secondaryLinkButtonType"
        :options="buttonTypeOptions"
      />
    </b-form-group>
    <!-- / Secondary Link Button Type -->

    <!-- Secondary Link Button Icon -->
    <b-form-group
      v-if="contentSettings.secondaryButtonActive"
      id="input-group-2"
      label="Secondary Button Icon"
      label-for="input-2"
      label-cols-sm="4"
      label-cols-lg="3"
    >
      <b-form-select
        v-model="form.secondaryLinkButtonIcon"
        :options="buttonIconOptions"
      />
    </b-form-group>
    <!-- / Secondary Link Button Icon -->
  </section>
</template>

<script>
export default {
  name: 'account-activation-success-design-form',
  data: () => {
    return {
      form: {
        salesBarTheme: {
          // expect that the data / combinations will change here e.g sales bar vs modal theme
          mainTheme: 'museum',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-1'
        },
        modalTheme: {
          // expect that the data / combinations will change here e.g sales bar vs modal theme
          mainTheme: 'flamingo',
          subsetTheme: 'dark-accent-1',
          subsetContrastTheme: 'type-2'
        },
        modalContentDirection: 'row',
        modalContentDesktopPosition: 'right',
        imageTintStrength: 40, // image tint over the sales, percent based
        imageTintStyle: 'vignette', // dark, vignette, blend
        primaryLinkButtonIcon: 'arrow',
        primaryLinkButtonType: 'pill',
        primaryLinkButtonStyle: 'solid',
        secondaryLinkButtonIcon: 'arrow',
        secondaryLinkButtonType: 'pill',
        secondaryLinkButtonStyle: 'outline'
      },
      imageTintStyleOptions: [
        {
          text: 'Vignette',
          value: 'vignette'
        },
        {
          text: 'Dark',
          value: 'dark'
        },
        {
          text: 'Blend',
          value: 'blend'
        }
      ],
      buttonTypeOptions: [
        {
          text: 'Text',
          value: 'text'
        },
        {
          text: 'Text Underline',
          value: 'text-underline'
        },
        {
          text: 'Square',
          value: 'square'
        },
        {
          text: 'Rounded',
          value: 'rounded'
        },
        {
          text: 'Pill',
          value: 'pill'
        }
      ],
      buttonStyleOptions: [
        {
          text: 'Solid',
          value: 'solid'
        },
        {
          text: 'Outline',
          value: 'outline'
        }
      ],
      buttonSizeOptions: [
        {
          text: 'Small',
          value: 'small'
        },
        {
          text: 'Standard',
          value: 'standard'
        },
        {
          text: 'Large',
          value: 'large'
        }
      ],
      buttonIconPositionOptions: [
        {
          text: 'Left',
          value: 'left'
        },
        {
          text: 'Right',
          value: 'right'
        }
      ],
      buttonIconOptions: [
        {
          text: 'Arrow',
          value: 'arrow'
        },
        {
          text: 'Tail Arrow Right',
          value: 'tail-arrow-right'
        },
        {
          text: 'Tail Arrow Down',
          value: 'tail-arrow-down'
        },
        {
          text: 'Triangle Right',
          value: 'triangle-right'
        },
        {
          text: 'External Link',
          value: 'external-link'
        },
        {
          text: 'Phone',
          value: 'phone'
        }
      ],
      modalContentDirectionOptions: [
        {
          text: 'Row',
          value: 'row'
        },
        {
          text: 'Column',
          value: 'column'
        }
      ],
      modalContentDesktopPosition: [
        {
          text: 'Left',
          value: 'left'
        },
        {
          text: 'Right',
          value: 'right'
        }
      ]
    }
  },
  computed: {
    contentSettings: function() {
      return this.$store.getters['sitegate/contentSettings']('account-activation-success')
    },
    styleSettings: function() {
      return this.$store.getters['sitegate/styleSettings']('account-activation-success')
    }
  },
  watch: {
    form: {
      handler(payload, old) {
        return this.$store.dispatch('sitegate/updateStyles', {
          gate: 'account-activation-success',
          data: payload
        })
      },
      deep: true
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify({ ...this.styleSettings }))
  }
}
</script>
